/* eslint-disable */
export default {
  confirmationInfo: '您上一个通话的未保存编辑将丢失，确定要处理新的通话吗？',
  log: '记录',
  save: '保存并处理新通话',
  discard: '丢弃并处理新通话',
  stay: '继续处理上一个通话',
} as const;

// @key: @#@"confirmationInfo"@#@ @source: @#@"Your unsaved edits on the previous call will be lost, are you sure you want to work on the new call?"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save & Work on New"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard & Work on New"@#@
// @key: @#@"stay"@#@ @source: @#@"Stay on Previous Work"@#@
